import { Table } from "@/features/Table";
import {
  type ConnectorConfig,
  connector_configs_columns,
} from "./columns";
import {
  type FilterConnectorConfigsSchema,
  FilterConnectorConfigs,
} from "./filter";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const client = "etl-quantilia";
const table_name = "connector_configs";

export const ConnectorConfigsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;
  const { t } = useTranslation();

  return (
    <Table<ConnectorConfig, FilterConnectorConfigsSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Connector Configurations",
      })}
      client={client}
      table_name={table_name}
      columns={connector_configs_columns}
      filter={<FilterConnectorConfigs />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
